<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">History</h3>
    </div>
  </div>
  <div class="margin-0 card-body navi-hover">
    <div>
      <div class="d-flex mb-2 pb-2 border-bottom font-weight-bold">
        <div class="mr-2" style="width: 150px">Date</div>
        <div class="flex-grow-1">
          <div class="d-flex">
            <td class="col">Field</td>
            <td class="col">Old Value</td>
            <td class="col">New Value</td>
          </div>
        </div>
      </div>
      <ng-container *ngFor="let history of histories">
        <div class="d-flex mb-2 pb-2 border-bottom">
          <div class="mr-2" style="width: 150px">{{ history.date }}</div>
          <div class="flex-grow-1">
            <ng-container *ngFor="let h of history.list">
              <div class="d-flex">
                <td class="col">{{ h.label }}</td>
                <td class="col">{{ h.old }}</td>
                <td class="col">{{ h.current }}</td>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="d-flex justify-content-center" *ngIf="numOfHistories == 0">No histories found</div>
  </div>
  <div class="card-footer" cdkFocusInitial>
    <div class="d-flex justify-content-between">
      <div class="mr-2"></div>
      <div>
        <button mat-button mat-dialog-close>Close</button>
      </div>
    </div>
  </div>
</div>
